import React, { useRef, useContext, useEffect } from "react";
import AppContext from "../../Context/AppContext";
import { ChatBox, ChatSender, Chat, Notification } from "../style";

const ChatMessage = () => {
  const chatBoxRef = useRef(null);
  const { chatList } = useContext(AppContext);

  useEffect(() => {
    const chatBox = chatBoxRef.current;
    chatBox.scrollIntoView({ behavior: "smooth", block: "center" });
  }, [chatList]);

  return (
    <ChatBox ref={chatBoxRef}>
      {chatList.map((item) => {
        const selfMessage = item.split("=>")[1] === undefined;
        const newUserMessage = item.split("joined")[1] !== undefined;
        const userKilledMessage = item.split("werewolf")[1] !== undefined;
        return selfMessage ? (
          <>
            {newUserMessage ? (
              <>
                <ChatSender></ChatSender>
                <Notification>{item.split("=>")[0]}</Notification>
              </>
            ) : (
              <>
                <ChatSender>{newUserMessage ? "" : "You:"}</ChatSender>
                <Chat>{item.split("=>")[0]}</Chat>
              </>
            )}
          </>
        ) : userKilledMessage ? (
          <>
            <ChatSender></ChatSender>
            <Notification>{item.split("=>")[1]}</Notification>
          </>
        ) : (
          <>
            <ChatSender>{item.split("=>")[0]}:</ChatSender>
            <Chat>{item.split("=>")[1]}</Chat>
          </>
        );
      })}
    </ChatBox>
  );
};

export default ChatMessage;
